import client from "./client";

export async function updateCountry(inputs: Record<string, unknown>) {
    const response = await client.post("/country", inputs);

    return response.data;
}
